import React from 'react';
import { SortRule } from '@economic/taco';
import usePagePreferences from './usePagePreferences';

type LegacySortRule = Record<string, 'asc' | 'desc'>;

export function useTableSortPreferences<T = any>(id: string) {
    const key = `table.${id}`;
    const [prefs, save] = usePagePreferences();
    const pref = prefs[key] as SortRule<T>[] | LegacySortRule | undefined;
    const sortRules = React.useMemo(() => {
        // Convert legacy sorting to new format
        if (pref && !Array.isArray(pref)) {
            return Object.entries(pref).map(([accessor, direction]) => ({
                accessor,
                desc: direction === 'desc',
            }));
        }
        return pref;
    }, [key, JSON.stringify(pref)]);

    const onSort = (sortRules: SortRule<T>[] | undefined) => {
        save({ [key]: sortRules });
    };

    return { sortRules, onSort };
}
